import React from 'react';
import { Route, IndexRoute } from 'react-router';

import {
    accountStatusChecked,
    checkEmailExists,
    setUpForm,
    setUpSocialForm,
    checkPasswordReset,
} from '../common/utils';
import { setEmail } from '../common/actions/auth';
import {
    RESET_PASSWORD_STATUS_PATH,
    SOFT_ACCOUNT_STATUS_PATH,
    LOG_IN_PATH,
    SIGN_UP_PATH,
    SOCIAL_SIGN_UP_PATH,
    LINK_ACCOUNTS_LOG_IN_PATH,
    CONFIRMATION_PATH,
    BASE_URL,
    RESET_PASSWORD_PATH,
    SET_PASSWORD_PATH,
    SET_LINKED_SOFT_ACCOUNTS_PATH,
} from '../common/constants';

import Page from './Page';
import ConnectedSignInScreen from '../common/containers/signin/ConnectedSignInScreen';
import ConnectedStatusScreen from '../common/containers/status/ConnectedStatusScreen';
import ConnectedSetPasswordScreen from '../common/containers/setPassword/ConnectedSetPasswordScreen';
import ConnectedConfirmationScreen from '../common/containers/confirmation/ConnectedConfirmationScreen';

const getRoutes = (pageInfo, store) => {
    const PageWithInfo = (props) => <Page {...pageInfo} {...props} />;

    const onEnter = (nextRouterState, replace) => {
        accountStatusChecked(store, replace);
    };

    const setUpSocialSingUpFormOnEnter = (nextRouterState, replace) => {
        setUpSocialForm(store, replace);
    };

    const setUpFormOnEnter = ({ location: { query } }) => {
        if (query.email) {
            store.dispatch(setEmail(query.email));
        }
        setUpForm(store);
    };

    const checkEmailOnEnter = (nextRouterState, replace) => {
        checkEmailExists(store, replace);
    };

    const checkResetOnEnter = ({ location: { query, pathname } }, replace) => {
        checkPasswordReset(store, query, replace, pathname);
    };

    return (
        <Route path={BASE_URL} component={PageWithInfo}>
            <IndexRoute
                component={ConnectedSignInScreen}
                onEnter={setUpFormOnEnter}
            />
            <Route
                path={CONFIRMATION_PATH}
                component={ConnectedConfirmationScreen}
            />
            <Route
                path={LOG_IN_PATH}
                component={ConnectedSignInScreen}
                onEnter={onEnter}
            />
            <Route
                path={SIGN_UP_PATH}
                component={ConnectedSignInScreen}
                onEnter={onEnter}
            />
            <Route
                path={SOCIAL_SIGN_UP_PATH}
                component={ConnectedSignInScreen}
                onEnter={setUpSocialSingUpFormOnEnter}
            />
            <Route
                path={LINK_ACCOUNTS_LOG_IN_PATH}
                component={ConnectedSignInScreen}
                onEnter={onEnter}
            />
            <Route
                path={SET_LINKED_SOFT_ACCOUNTS_PATH}
                component={ConnectedSignInScreen}
                onEnter={checkEmailOnEnter}
            />
            <Route
                path={RESET_PASSWORD_PATH}
                component={ConnectedSetPasswordScreen}
                onEnter={checkResetOnEnter}
            />
            <Route
                path={SET_PASSWORD_PATH}
                component={ConnectedSetPasswordScreen}
                onEnter={checkResetOnEnter}
            />
            <Route path="status">
                <Route
                    path={SOFT_ACCOUNT_STATUS_PATH}
                    component={ConnectedStatusScreen}
                />
                <Route
                    path={RESET_PASSWORD_STATUS_PATH}
                    component={ConnectedStatusScreen}
                />
            </Route>
        </Route>
    );
};

export default getRoutes;
